// THUMBNAILS

// ---- MODELS ----
// Colors
import doorSEK from "../assets/thumbnails/models/Door_SEK.png";
import doorRegular from "../assets/thumbnails/models/Door_Regular.png";

// ---- MODULES ----
import moduleSingleFold from "../assets/thumbnails/modules/Module_SingleFold.png";
import moduleDoubleFold from "../assets/thumbnails/modules/Module_DoubleFold.png";
import moduleFireDoor from "../assets/thumbnails/modules/Module_FireDoor.png";
import moduleWoodPanels from "../assets/thumbnails/modules/Module_WoodPanels.png";
import moduleWoodenDoorFrame from "../assets/thumbnails/modules/Module_WoodenDoorFrame.png";
import moduleRam from "../assets/thumbnails/modules/Module_Ram.png";
import moduleLock from "../assets/thumbnails/modules/Module_Lock.png";

// ---- FUNCTIONS ----
import functionOpenDoor from "../assets/thumbnails/functions/Function_OpenDoor.png";
import functionCloseDoor from "../assets/thumbnails/functions/Function_CloseDoor.png";
import functionModuleChange from "../assets/thumbnails/functions/Function_ModuleChange.png";
import functionReplace_DornBlock from "../assets/thumbnails/functions/Function_Replace_DornBlock.png";
import functionRotateDoor180 from "../assets/thumbnails/functions/Function_RotateDoor180.png";
import functionSuspension from "../assets/thumbnails/functions/Function_Suspension.png";

// ---- CAMERAS ----
import resetCamera from "../assets/thumbnails/cameras/Reset_Camera.png";

export const actionList = [
  {
    name: {
      en: "Models",
      de: "Modelle",
    },
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: {
          en: "SEK",
          de: "SEK",
        },
        image: doorSEK,
        action: {
          descriptor: {
            Do: "sek",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Regular",
          de: "Regular",
        },
        image: doorRegular,
        action: {
          descriptor: {
            Do: "reg",
          },
          type: "select",
        },
      },
    ],
  },
  {
    name: {
      en: "Modules",
      de: "Module",
    },
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: {
          en: "Single-Fold",
          de: "Einfachfalz-Modul",
        },
        image: moduleSingleFold,
        action: {
          descriptor: {
            Mod: "sf",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Double-Fold",
          de: "Doppelfalz-Modul",
        },
        image: moduleDoubleFold,
        action: {
          descriptor: {
            Mod: "df",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Wood Panels",
          de: "Holzpaneele",
        },
        image: moduleWoodPanels,
        action: {
          descriptor: {
            Mod: "wp",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Wooden Door Frame",
          de: "Holztürstock-Modul",
        },
        image: moduleWoodenDoorFrame,
        action: {
          descriptor: {
            Mod: "wdf",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Fire Door",
          de: "Brandschutztür-Modul",
        },
        image: moduleFireDoor,
        action: {
          descriptor: {
            Mod: "fd",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Lock",
          de: "Schlosskasten-Modul",
        },
        image: moduleLock,
        action: {
          descriptor: {
            Mod: "lo",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Ram",
          de: "Rammenaufsatz-Modul",
        },
        image: moduleRam,
        action: {
          descriptor: {
            Mod: "ram",
          },
          type: "select",
        },
      },
    ],
  },
  {
    name: {
      en: "Functions",
      de: "Funktionen",
    },
    action: {
      type: "tab",
    },
    subActions: [
      {
        name: {
          en: "Open door",
          de: "Tür öffnen",
        },
        image: functionOpenDoor,
        action: {
          descriptor: {
            Anim: "open_door",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Close door",
          de: "Tür schließen",
        },
        image: functionCloseDoor,
        action: {
          descriptor: {
            Anim: "close_door",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Rotate door 180°",
          de: "Tür um 180° drehen",
        },
        image: functionRotateDoor180,
        action: {
          descriptor: {
            Anim: "rot_180",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Module change",
          de: "Modul wechseln",
        },
        image: functionModuleChange,
        action: {
          descriptor: {
            Anim: "module_change",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Replace dorn block",
          de: "Dornblock ersetzen",
        },
        image: functionReplace_DornBlock,
        action: {
          descriptor: {
            Anim: "dornblock",
          },
          type: "select",
        },
      },
      {
        name: {
          en: "Suspension",
          de: "Federung",
        },
        image: functionSuspension,
        action: {
          descriptor: {
            Anim: "suspension",
          },
          type: "select",
        },
      },
    ],
  },
];

export const cameraOptions = {
  name: {
    en: "Reset Camera",
    de: "Kamera zurücksetzen",
  },
  image: resetCamera,
  action: {
    descriptor: {
      reset_cam: "true",
    },
    type: "select",
  },
};
